import React, { FC } from "react"
import { Error } from "@bancacfplus/Error"
import { Heading } from "@bancacfplus/Heading"
import style from "./UserNotAllowed.module.scss"
import { brand } from "../../consts/brand"

export const UserNotAllowed: FC = () => {
  return (
    <div className={style.wrapper}>
      <Error>
        <div className={style.container}>
          <Heading as="h1" variant="h4">
            Utente non autorizzato
          </Heading>
          <p className={style.detail}>Non ci risulta che abbia accesso alla piattaforma clienti {brand.name}.</p>
          <p className={style.detail}>
            Se credi sia un errore, contattaci al{" "}
            <a className={style.link} href={brand.supportPhoneHref}>
              {brand.supportPhone}
            </a>{" "}
            oppure scrivi una mail a{" "}
            <a className={style.link} href={`mailto:${brand.supportEmail}`}>
              {brand.supportEmail}
            </a>
            .
          </p>
        </div>
      </Error>
    </div>
  )
}
